import { StreamVideoClient,StreamVideo,StreamCall, useCall, useCallStateHooks, ParticipantView } from "@stream-io/video-react-sdk";
import hbrIcon from '../otherImg/hrmwlitelogo.png';
import { useContext, useState} from "react";
import { AuthContext } from "../AuthContext";
import { ref, set } from "firebase/database";
import { realTimeDB } from "../firebase";
import { CopyAll } from "@mui/icons-material";
import { HbrDropdownIcon } from "./Mycustomsvgicons";
import { format } from "date-fns";
import { Timestamp } from "firebase/firestore";




    export const BackstageView=({token,apiKey,liveDesc})=>{
      const userId = 'horemow_media';
      const callid = `horemowmediahbrlive`;
      const {userName} = useContext(AuthContext);
      const {profile_pic} = useContext(AuthContext);

    const user = {
        id: userId,
        name: userName,
        image: profile_pic !== null && profile_pic !== "" ? profile_pic : hbrIcon,
    };

   const client = new StreamVideoClient({apiKey,user,token});
   const call = client.call('livestream',callid);
    call.join({create: true});


      return (
      <StreamVideo client={client}>
        <StreamCall call={call}>
          <MyLiveStreamUI token = {token} liveDesc={liveDesc}/>
        </StreamCall>
      </StreamVideo>
      )
    };

    export const MyLiveStreamUI =({token,liveDesc})=>{
    const [hlsUrl,setHlsUrl]=useState("");
    const [copied,setCopied]=useState(false);
    const [showStreamDetails,setShowStreamDetails]=useState(false);
    const call = useCall();
    const {useIsCallLive,useLocalParticipant,useCallIngress} = useCallStateHooks();
    const postLiveID = format(new Date(),"yyyyMMddHHmmss");
    const postLiveDate = format(new Date(), "yyyy-MM-dd");
    const now = Timestamp.now();
    const utcTime = new Date(now?.toDate()).toUTCString();
      
   
    const isCallLive = useIsCallLive();
    const localParticipant = useLocalParticipant();
    // const egress = useCallEgress();
    const ingress = useCallIngress();
    const rtmpURL = ingress?.rtmp.address;
    const streamKey = token;

    const handleStartLivestream=()=>{
      call?.goLive({start_hls: true});
      // set(ref(realTimeDB,"Banner/hbrLiveSettings/live"),true);
    };

    const handleGetHlsLink=async()=>{
      try {
        const resp = await call.getOrCreate();
        const URL = resp.call.egress.hls?.playlist_url;
        set(ref(realTimeDB,"Banner/hbrLiveSettings/hlsUrl"),URL);
        set(ref(realTimeDB,"Banner/hbrLiveSettings/live"),true);
        setHlsUrl(URL);
      } catch (error) {
        alert("failed to start hls, retry");
        console.log(error);
      }
   
    };

    const handleEndLivecall=async()=>{
      try {
        call?.endCall();
        set(ref(realTimeDB,"Banner/hbrLiveSettings/live"),false);
        set(ref(realTimeDB,`postLive/${postLiveID}`),{
          url: hlsUrl,
          date: postLiveDate,
          utcTime,
          liveDesc
        });
        await call.stopHLS();
      } catch (error) {
        alert("issue encountered while stopping hls stream");
        console.log(error);
      }
   
    };

    const handleCopy=async(texttocopy)=>{
      if (navigator.clipboard) {
        try {
          await navigator.clipboard.writeText(texttocopy);
          setCopied(true);

          const timeid = setTimeout(() => {
            setCopied(false);
          }, 2000);
          return()=>clearTimeout(timeid);
        } catch {
          
        }
         
      }
    };



    return (
      <div style={{ display: 'grid', placeItems:"center", gap: '10px',overflow:"auto",width:"100%",backgroundColor:"#252a41" }}>
        <div
          style={{
            alignSelf: 'flex-start',
            color: 'white',
            backgroundColor: 'blue',
            borderRadius: '8px',
            padding: '4px 6px',
          }}
        >
        </div>
        <div style={{ flex: 1 }}>
          {localParticipant && (
            <ParticipantView
              participant={localParticipant}
              ParticipantViewUI={null}
            />
          )}
        </div>
        <div >
          {isCallLive ? (
            <div className="flex-column2" style={{width:"100%",gap:"20px"}}>
                
                    <div style={{width:"70%"}}>
                    <pre style={{whiteSpace:"pre-wrap",width:"90%",color:"white"}}>{`Current livestream supporting high latency is On.✔ This is suitable for Users with \nultra high internet speed. Start Hls to support low latency.`}</pre>
                    </div>
                  
                    {hlsUrl !== "" && 
                            <div className="flex-row2" style={{width:"70%",gap:"10px"}}>
                             <div style={{width:"50%",display:"flex",overflow:"hidden"}}>
                             <pre id="countreactiontext" style={{width:"80%",color:"white",fontWeight:"bold",whiteSpace:"pre-wrap",wordBreak:"break-word"}}>
                              {`Http Live Stream (Hls): ${hlsUrl}`}
                              </pre>
                             </div>
                       
                             <button style={{backgroundColor:"white",border:"none",borderRadius:"5px",padding:"10px",fontWeight:"bold",cursor:"pointer",caretColor:"transparent"}}
                                   onClick={()=>handleCopy(hlsUrl)}>
                             {`${copied ? 'copied✔' : 'Copy Hls Url'}`}<CopyAll/>
                             </button>
                        </div>
                    }
           
                    <div className="flex-row2" style={{position:"relative",style:"100%",gap:"10px"}}>

                        <button onClick={handleEndLivecall}
                          style={{backgroundColor:"#eb268f",border:"none",borderRadius:"10px",color:"white",padding:"10px",fontWeight:"bold",cursor:"pointer",caretColor:"transparent"}}>
                              End Broadcast call
                        </button>

                        <button onClick={handleGetHlsLink}
                          style={{backgroundColor:"#0b6b93",border:"none",borderRadius:"10px",color:"white",padding:"10px",fontWeight:"bold",cursor:"pointer",caretColor:"transparent"}} disabled={hlsUrl !== "" ? true : false}>
                              {`${hlsUrl !== ""? 'Hls started':'Start Hls'}`}
                        </button>
                  

                          <button style={{backgroundColor:"transparent",border:"none",borderRadius:"10px",color:"white",padding:"10px",fontWeight:"bold",cursor:"pointer",caretColor:"transparent"}}
                                  onClick={() => setShowStreamDetails(prev => !prev)}>
                            
                            rtmp stream details <HbrDropdownIcon width="2em" height="2em" fillColour="white"/>
                        </button>

                        {showStreamDetails && 

                        <div className="flex-column2" style={{position:"absolute",bottom:"100%",width:"400px",height:"auto",borderRadius:"10px", backgroundColor:"#101010",padding:"10px",zIndex:"1"}}>
                              <div className="flex-row2" style={{width:"100%", gap:"10px"}}>
                                  <div style={{width:"50%",display:"flex",overflow:"hidden"}}>
                                  <p id="countreactiontext" style={{color:"white",fontWeight:"bold",width:"100%"}}>rtmp url: {rtmpURL}</p>
                                  </div>
                                
                                  <button style={{backgroundColor:"white",border:"none",borderRadius:"5px",padding:"10px",fontWeight:"bold",cursor:"pointer",caretColor:"transparent"}}
                                  onClick={()=>handleCopy(rtmpURL)}>
                                    {`${copied ? 'copied✔' : 'Copy url'}`}<CopyAll/>
                                  </button>
                              </div>

                              <div className="flex-row2" style={{width:"100%",gap:"10px"}}>
                                    <div style={{width:"50%",display:"flex",overflow:"hidden"}}>
                                    <p id="countreactiontext" style={{width:"100%",color:"white",fontWeight:"bold"}}>stream key: {streamKey}</p>
                                    </div>
                              
                                  <button style={{backgroundColor:"white",border:"none",borderRadius:"5px",padding:"10px",fontWeight:"bold",cursor:"pointer",caretColor:"transparent"}}
                                          onClick={()=>handleCopy(streamKey)}>
                                    {`${copied ? 'copied✔' : 'Copy key'}`}<CopyAll/>
                                  </button>
                              </div>
                        </div>
                        
                        }

                    </div>
                
            </div>
        
          ) : (
            <div className="flex-column2" style={{width:"100%",overflow:"auto",gap:"20px"}}>
                    {localParticipant && 
                      <button onClick={handleStartLivestream}
                      style={{backgroundColor:"green",border:"none",borderRadius:"10px",color:"white",padding:"10px",fontWeight:"bold",cursor:"pointer",caretColor:"transparent"}}>
                      Go Live
                    </button>
                    }
                 
                    <div style={{width:"50%"}}>
                    <pre style={{whiteSpace:"pre-wrap",width:"90%",color:"white"}}>
                      {`Stream from your camera or Stream from a broadcasting software.\n\nStream from camera source:\nDisable camera if you decide to stream from a broadcasting software. Enable the camera if you decide to use a camera source. To disable or enable camera, click on the control camera button. By default your browser will select the available cameras it has access to. Go to browser settings to manually change or select the camera source you desire.\n\nStream from broadcasting software:\nUse any broadcasting software to stream but we recommend using OBS. Open OBS studio, Navigate to the settings Tab, on the left side bar of the settings menu, click on stream, in the stream set up section, there are three setups namely Service: , Server: , Stream key: \nselect custom for the service section, copy the rtmp url and paste it in the server placeholder, copy the stream key and paste it in the Stream key placeholder. Click on "Apply" and "Ok" on the bottom of the OBS studio to finish the stream setup.`}
                    </pre>
                    </div>
                
                   <div className="flex-row2" style={{width:"100%", gap:"10px"}}>
                        <div style={{width:"50%",display:"flex",overflow:"hidden"}}>
                        <p id="countreactiontext" style={{color:"white",fontWeight:"bold",width:"100%"}}>rtmp url: {rtmpURL}</p>
                        </div>
                      
                        <button style={{backgroundColor:"white",border:"none",borderRadius:"5px",padding:"10px",fontWeight:"bold",cursor:"pointer",caretColor:"transparent"}}
                        onClick={()=>handleCopy(rtmpURL)}>
                          {`${copied ? 'copied✔' : 'Copy url'}`}<CopyAll/>
                        </button>
                   </div>
               
                 <div className="flex-row2" style={{width:"100%",gap:"10px"}}>
                      <div style={{width:"50%",display:"flex",overflow:"hidden"}}>
                      <p id="countreactiontext" style={{width:"100%",color:"white",fontWeight:"bold"}}>stream key: {streamKey}</p>
                      </div>
                
                    <button style={{backgroundColor:"white",border:"none",borderRadius:"5px",padding:"10px",fontWeight:"bold",cursor:"pointer",caretColor:"transparent"}}
                            onClick={()=>handleCopy(streamKey)}>
                      {`${copied ? 'copied✔' : 'Copy key'}`}<CopyAll/>
                      </button>
                 </div>

            </div>
         
          )}
        </div>
      </div>
    );

    };
  

